<template>
	<div class="update">
		<div class="tabs">
			<div :class="isOpen ? 'tab_btn' : 'tab_btn active_btn'" @click="handleTabNo">未开发票</div>
			<div :class="isOpen ? 'tab_btn active_btn' : 'tab_btn'" @click="handleTabYes">已开发票</div>
		</div>
		<div class="wrap">
			<div class="not_open" v-if="!isOpen">
				<div class="list">
					<div class="item" v-for="(item, index) in list" :key="index">
						<div class="item_cell" @click="handleCopy('777')">
							<div class="item_cell_label">发票金额：</div>
							<div class="item_cell_val">¥777</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_cell" @click="handleCopy('2022-03-17')">
							<div class="item_cell_label">申请日期：</div>
							<div class="item_cell_val">2022-03-17</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_cell" @click="handleCopy('增值税普通发票 - 企业')">
							<div class="item_cell_label">发票类型：</div>
							<div class="item_cell_val">增值税普通发票 - 企业</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_cell" @click="handleCopy('上海米因大数据科技有限公司')">
							<div class="item_cell_label">发票抬头：</div>
							<div class="item_cell_val">上海米因大数据科技有限公司</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_cell" @click="handleCopy('91310118301670964P')">
							<div class="item_cell_label">购方税号：</div>
							<div class="item_cell_val">91310118301670964P</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_cell" @click="handleCopy('米因大数据健康评估')">
							<div class="item_cell_label">发票内容：</div>
							<div class="item_cell_val">米因大数据健康评估</div>
							<div class="item_copy_icon_box">
								<el-image class="item_copy_icon" :src="require('@/assets/images/copy.png')"></el-image>
							</div>
						</div>
						<div class="item_foot">
							<el-button class="item_btn">已开发票</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="yes_open" v-if="isOpen">
				<div class="list">
					<div class="item" v-for="(item, index) in list" :key="index">
						<div class="item_cell">
							<div class="item_cell_label">发票金额：</div>
							<div class="item_cell_val">¥777</div>
						</div>
						<div class="item_cell">
							<div class="item_cell_label">申请日期：</div>
							<div class="item_cell_val">2022-03-17</div>
						</div>
						<div class="item_cell">
							<div class="item_cell_label">发票类型：</div>
							<div class="item_cell_val">增值税普通发票 - 企业</div>
						</div>
						<div class="item_cell">
							<div class="item_cell_label">发票抬头：</div>
							<div class="item_cell_val">上海米因大数据科技有限公司</div>
						</div>
						<div class="item_cell">
							<div class="item_cell_label">购方税号：</div>
							<div class="item_cell_val">91310118301670964P</div>
						</div>
						<div class="item_cell">
							<div class="item_cell_label">发票内容：</div>
							<div class="item_cell_val">米因大数据健康评估</div>
						</div>
						<div class="item_foot">
							<el-popover
							    placement="bottom-end"
								width="382"
							    trigger="hover">
								<div class="popover_wrap">
									<div class="popover_box">
										<div class="popover_cell">
											<div class="popover_cell_label">收件人：</div>
											<div class="popover_cell_val">赵妹妹</div>
										</div>
										<div class="popover_cell">
											<div class="popover_cell_label">电话：</div>
											<div class="popover_cell_val">17890987654</div>
										</div>
										<div class="popover_cell">
											<div class="popover_cell_label">地址：</div>
											<div class="popover_cell_val">上海市 长宁区 古北路507号 申凌大厦1204室</div>
										</div>
									</div>
									<div class="popover_copy">
										一键复制
									</div>
								</div>
								<el-button slot="reference" class="item_btn">查看地址</el-button>
							</el-popover>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
// import {   } from '@/utils/axios.js'

export default {
	name: 'adminInvoice',
	data() {
		return {
			submiting: false, // 正在请求
			list: [{},{},{},{},{},{}],
			isOpen: false,
			visible: false
		};
	},

	mounted() {
		
		
	},
	components: {},
	watch: {
		
	},
	methods: {
		handleTabNo(){
			this.isOpen = false
		},
		handleTabYes() {
			this.isOpen = true
		},
		handleCopy(string) {
			let url = string;
			let oInput = document.createElement('input');
			oInput.value = url;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象;
			document.execCommand('Copy')
			this.$message.success("复制成功") 
			oInput.remove()
		},
	}
};
</script>

<style scoped>
.wrap {
	margin-top: 24px;
}
.popover_wrap {
	padding: 2px;
}
.popover_box {
		display: flex;
		align-items: center;
		flex-direction: row;
		flex-wrap: wrap;
}
.popover_cell {
	display: flex;
	align-items: flex-start;
	margin-bottom: 8px;
}
.popover_cell_label {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #AEB0BB;
	line-height: 20px;
}
.popover_cell_val {
	flex: 1;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #293033;
	line-height: 20px;
	margin-right: 40px;
}
.popover_copy {
	font-size: 14px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #6883FB;
	line-height: 18px;
	text-align: right;
	cursor: pointer;
}
.item_cell::hover .item_copy_icon_box{
	display: block;	
}

.item_copy_icon_box {
	display: none;
	width: 20px;
	height: 20px;
}
.item_copy_icon {
	width: 20px;
	height: 20px;
}

</style>
<style lang="scss" scoped>
.update {
	padding: 28px 24px;
	
	.tabs {
		display: flex;
		align-items: center;
	}
	
	.tab_btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 86px;
		height: 34px;
		font-size: 15px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		border-radius: 4px;
		border: 1px solid #DBDDE6;
		margin-right: 12px;
		cursor: pointer;
	}
	
	.active_btn {
		color: #fff;
		background: #6883FB;
		border: none;
	}
	.list{
		display: flex;
		align-items: center;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.item {
		width: 382px;
		padding: 20px;
		margin: 0 12px 12px 0;
		border: 1px solid #E5E8F5;
		border-radius: 8px;
	}
	.item_cell {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		cursor: pointer;
		
		&:hover .item_copy_icon_box {
			display: block;
		}
		
	}
	.item_cell_label {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #AEB0BB;
		line-height: 20px;
	}
	.item_cell_val {
		flex: 1;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #293033;
		line-height: 20px;
	}
	.item_foot {
		display: flex;
		justify-content: flex-end;
	}
	.item_btn{
		width: 96px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #6883FB;
		border-radius: 17px;
		border: 1px solid #6883FB;
		background-color: #fff;
	}
	
	
}

</style>
